
document.addEventListener("DOMContentLoaded", function () {

  function addVendorSwatchLinks() {

    const upholsterySwatches = document.querySelectorAll(
      '.swatches div[option-name="Upholstery"]'
    );

    const vendorElement = document.querySelector('.vendor .brand');

    if (!upholsterySwatches.length || !vendorElement) return;

    const vendor = vendorElement.innerText.trim();
    const vendorText = vendor.toLowerCase();

    let pageLink = "";

    if (vendorText.includes("bauhaus")) {
      pageLink = "/pages/bauhaus-studio-swatches-to-order";
    } else if (vendorText.includes("mcm")) {
      pageLink = "/pages/mcm-house-swatches-to-order";
    } else if (vendorText.includes("camerich")) {
      pageLink = "/pages/camerich-swatches-to-order";
    }

    if (!pageLink) return;

    upholsterySwatches.forEach(function (swatch) {

      const ul = swatch.querySelector(".swatch-single");

      if (!ul) return;

      if (
        swatch.querySelector(
          ".view-all-vendor-swatches"
        )
      ) {
        return;
      }

      const wrapper =
        document.createElement("span");

      wrapper.className =
        "view-all-vendor-swatches";

      const link =
        document.createElement("a");

      link.href = pageLink;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      link.textContent = "View all";

      wrapper.appendChild(link);

      wrapper.appendChild(
        document.createTextNode(
          " " + vendor + " Swatches"
        )
      );

      ul.insertAdjacentElement(
        "afterend",
        wrapper
      );

    });

  }


  function getProductHandle() {

    const path =
      window.location.pathname;

    const match =
      path.match(
        /\/products\/([^\/]+)/
      );

    if (!match) return null;

    return match[1];

  }


  let productData = null;


  async function getProductData() {

    if (productData) {
      return productData;
    }

    const handle =
      getProductHandle();

    if (!handle) {
      return null;
    }

    try {

      const response =
        await fetch(
          `/products/${handle}.js`
        );

      if (!response.ok) {
        return null;
      }

      productData =
        await response.json();

      return productData;

    } catch (error) {

      console.error(
        "Could not load product data:",
        error
      );

      return null;

    }

  }


  async function getSelectedVariant(
    variantId
  ) {

    if (!variantId) {
      return null;
    }

    const product =
      await getProductData();

    if (
      !product ||
      !product.variants
    ) {
      return null;
    }

    return product.variants.find(
      function (variant) {

        return String(variant.id) ===
          String(variantId);

      }
    );

  }


  function getDrawerImage() {

    const drawerImage =
      document.querySelector(
        ".swatch-drawer-product-image img"
      );

    if (drawerImage) {
      return drawerImage;
    }

    const directImage =
      document.querySelector(
        "img.swatch-drawer-product-image"
      );

    if (directImage) {
      return directImage;
    }

    return null;

  }


  async function updateDrawerImage(
    variantId
  ) {

    if (!variantId) {
      return;
    }

    const drawerImage =
      getDrawerImage();

    if (!drawerImage) {
      return;
    }

    const variant =
      await getSelectedVariant(
        variantId
      );

    if (!variant) {
      return;
    }

    if (
      !variant.featured_image ||
      !variant.featured_image.src
    ) {
      return;
    }

    let imageUrl =
      variant.featured_image.src;

    if (
      imageUrl.startsWith("//")
    ) {
      imageUrl =
        "https:" + imageUrl;
    }

    drawerImage.src =
      imageUrl;

    drawerImage.removeAttribute(
      "srcset"
    );

    drawerImage.removeAttribute(
      "sizes"
    );

    if (variant.title) {
      drawerImage.alt =
        variant.title;
    }

  }


  function getCurrentVariantId() {

    const variantInput =
      document.querySelector(
        'form[action*="/cart/add"] input[name="id"]'
      );

    if (
      variantInput &&
      variantInput.value
    ) {
      return variantInput.value;
    }

    const variantSelect =
      document.querySelector(
        'select[name="id"]'
      );

    if (
      variantSelect &&
      variantSelect.value
    ) {
      return variantSelect.value;
    }

    const urlParams =
      new URLSearchParams(
        window.location.search
      );

    return urlParams.get(
      "variant"
    );

  }


  function setupVariantImageSync() {

    document.addEventListener(
      "variant:change",
      function (event) {

        let variantId =
          null;

        if (
          event.detail &&
          event.detail.variant
        ) {

          variantId =
            event.detail.variant.id;

        }

        if (
          !variantId &&
          event.detail &&
          event.detail.variantId
        ) {

          variantId =
            event.detail.variantId;

        }

        if (!variantId) {

          variantId =
            getCurrentVariantId();

        }

        if (!variantId) {
          return;
        }

        updateDrawerImage(
          variantId
        );

      }
    );


    document.addEventListener(
      "change",
      function (event) {

        if (!event.target) {
          return;
        }

        if (
          event.target.name !== "id"
        ) {
          return;
        }

        const variantId =
          event.target.value;

        if (!variantId) {
          return;
        }

        updateDrawerImage(
          variantId
        );

      }
    );


    const initialVariantId =
      getCurrentVariantId();

    if (initialVariantId) {

      updateDrawerImage(
        initialVariantId
      );

    }

  }


  addVendorSwatchLinks();

  setupVariantImageSync();


  const observer =
    new MutationObserver(
      function () {

        addVendorSwatchLinks();

        const currentVariantId =
          getCurrentVariantId();

        if (currentVariantId) {
          updateDrawerImage(
            currentVariantId
          );
        }

      }
    );


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

});
